import { IErrorResponseType } from "../../constants/commonTypes"

export const GET_ACCOUNT_BALANCE = "GET_ACCOUNT_BALANCE"
export const GET_ACCOUNT_BALANCE_REQUEST = "GET_ACCOUNT_BALANCE_REQUEST"
export const GET_ACCOUNT_BALANCE_SUCCESS = "GET_ACCOUNT_BALANCE_SUCCESS"
export const GET_ACCOUNT_BALANCE_FAILURE = "GET_ACCOUNT_BALANCE_FAILURE"

export const GET_PAYMENT_DETAILS = "GET_PAYMENT_DETAILS"
export const GET_PAYMENT_DETAILS_REQUEST = "GET_PAYMENT_DETAILS_REQUEST"
export const GET_PAYMENT_DETAILS_SUCCESS = "GET_PAYMENT_DETAILS_SUCCESS"
export const GET_PAYMENT_DETAILS_FAILURE = "GET_PAYMENT_DETAILS_FAILURE"

export const GET_TRANSACTION_SUMMARY_RESET = "GET_TRANSACTION_SUMMARY_RESET"


// Get Account Balance
export interface GetAccountBalanceAction {
  type: typeof GET_ACCOUNT_BALANCE
}

export interface GetAccountBalanceRequestAction {
  type: typeof GET_ACCOUNT_BALANCE_REQUEST;
}

export interface GetAccountBalanceSuccessAction {
  type: typeof GET_ACCOUNT_BALANCE_SUCCESS;
  accountCurrency: string;
  accBalance: number;
  accountNo: string;
  isAccountDetailsFetched: boolean;
}

export interface GetAccountBalanceFailureAction {
  type: typeof GET_ACCOUNT_BALANCE_FAILURE;
  error: Error | string | null | IErrorResponseType;
}



// Get Payment Summary
export interface GetPaymentSummaryAction {
  type: typeof GET_PAYMENT_DETAILS
}

export interface GetPaymentSummaryRequestAction {
  type: typeof GET_PAYMENT_DETAILS_REQUEST;
}

export interface GetPaymentSummarySuccessAction {
  type: typeof GET_PAYMENT_DETAILS_SUCCESS;
  amount: number;
  inrAmt: number;
  bankCharges: number;
  sourceTax: number;
  gst: number;
  totalAmt: number;
  rate: number;
  originalRate:number,
  currency: string;
  fccTax: number;
  commissionAmount: number;
  isPaymentDetailsFetched: boolean;
}

export interface GetPaymentSummaryFailureAction {
  type: typeof GET_PAYMENT_DETAILS_FAILURE;
  error: Error | string | null | IErrorResponseType;
}


export interface GetTransactionSummaryResetAction {
  type: typeof GET_TRANSACTION_SUMMARY_RESET
}


export type PaymentAction =
  | GetAccountBalanceAction
  | GetAccountBalanceRequestAction
  | GetAccountBalanceSuccessAction
  | GetAccountBalanceFailureAction

  | GetPaymentSummaryAction
  | GetPaymentSummaryRequestAction
  | GetPaymentSummarySuccessAction
  | GetPaymentSummaryFailureAction

  | GetTransactionSummaryResetAction;
